import { createAxiosClient } from 'src/utils/axiosClient';

/**
 * Cart Order Service client for public RESTful calls
 *
 */
export const cartOrderPublicClient = (version: number) =>
  createAxiosClient({
    baseURL: `/api/v${version}/cart-order-rest`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    withCredentials: true,
  });

export const getCartOrderInternalClient = (version: number) =>
  createAxiosClient({
    baseURL: `${process.env.CART_ORDER_BASE_REST_URL}/v${version}/internal`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'territory-api-key': process.env.CART_ORDER_INTERNAL_API_KEY,
    },
    withCredentials: true,
  });
